import { useEffect, useRef, useState } from 'react'
import './FullKeyButton.css'

interface FullKeyButtonProps {
    text: string
    keyboardKey?: string
    theme?: 'light' | 'dark'
}

export const FullKeyButton = ({ text, keyboardKey, theme = 'dark' }: FullKeyButtonProps) => {
    const [pressed, setPressed] = useState(false)
    const targetKey = (keyboardKey ?? text).toLowerCase()
    const heldRef = useRef(false)

    useEffect(() => {
        const onDown = (e: KeyboardEvent) => {
            if (e.key.toLowerCase() !== targetKey) return
            heldRef.current = true
            setPressed(true)
        }
        const onUp = (e: KeyboardEvent) => {
            if (e.key.toLowerCase() !== targetKey) return
            heldRef.current = false
            requestAnimationFrame(() => {
                if (!heldRef.current) setPressed(false)
            })
        }
        const onBlur = () => {
            heldRef.current = false
            setPressed(false)
        }

        window.addEventListener('keydown', onDown)
        window.addEventListener('keyup', onUp)
        window.addEventListener('blur', onBlur)

        return () => {
            window.removeEventListener('keydown', onDown)
            window.removeEventListener('keyup', onUp)
            window.removeEventListener('blur', onBlur)
        }
    }, [targetKey])

    return (
        <div className={`full-key-button theme-${theme}${pressed ? ' pressed' : ''}`}>
            <p className="full-key-button-text">
                {text}
            </p>
        </div>
    )
}
